import React, { useContext, useEffect, useState } from "react";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Image,
  KeyboardAvoidingView,
  Platform,
  ScrollView} from "react-native";
import * as LocalAuthentication from "expo-local-authentication";
import { AuthContext } from "../../../contexts/AuthContext";
import SignInStyle from "../SignInPageStyle";
import * as Google from "expo-auth-session/providers/google";
import * as jwtDecode from "jwt-decode";
import Toast from "react-native-toast-message";
import {
  GoogleSignin,
  GoogleSigninButton,
  isErrorWithCode,
  isSuccessResponse,
  statusCodes} from "@react-native-google-signin/google-signin";
import commonStyles from "../../../styles/commonStyles";
import Constants from "expo-constants";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ApiResponse } from "../../../types/ApiResponse";
import { ApiService, setAuthToken } from "../../../service/ApiService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Prompt } from "expo-auth-session";
import OverlayLoader from "../../../components/LoadingOverlay";
import { SafeAreaView } from "react-native-safe-area-context";
import AppText from "../../../components/AppText";
interface BiometricAuthScreenProps {
  onAuthSuccess: () => void;
}

type RootStackParamList = {
  Investments: undefined;
};

const webClientId = Constants.expoConfig?.extra?.WEB_ID;
const iosClientId = Constants.expoConfig?.extra?.IOS_ID;
const androidClientId = Constants.expoConfig?.extra?.ANDROID_ID;
// type NavigationProp = StackNavigationProp<RootStackParamList, "Investments">;

const BiometricAuthScreen: React.FC<BiometricAuthScreenProps> = ({
  onAuthSuccess}) => {
  const { logout } = useContext(AuthContext);
  const [isBiometricAvailable, setIsBiometricAvailable] =
    useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [failedAttempts, setFailedAttempts] = useState<number>(0); // Track failures
  GoogleSignin.configure({
    webClientId: webClientId,
    offlineAccess: true,
    forceCodeForRefreshToken: true,
    iosClientId: iosClientId});
  const navigation = useNavigation<NavigationProp<any>>();
  const [isGoogleAuth, setIsGoogleAuth] = useState(false);
  const toggleSwitch = () => setIsGoogleAuth((previousState) => !previousState);
  const { setUserToken } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    email: "",
    password: ""});

  const [request, response, promptAsync] = Google.useAuthRequest({
    iosClientId: iosClientId,
    androidClientId: androidClientId,
    webClientId: webClientId,
    prompt: "select_account" as Prompt,
    responseType: "id_token",
    scopes: ["profile", "email"]});

  useEffect(() => {
    if (response?.type === "success" && "params" in response) {
      const token = response?.params?.id_token;
      console.log("the log", response);
      if (token) decodeToken(token);
      sendTokenToApi(token);
    }
  }, [response]);
  // const navigation = useNavigation<NavigationProp>();
  useEffect(() => {
    checkBiometricSupport();
  }, []);

  const checkBiometricSupport = async () => {
    try {
      const hasHardware = await LocalAuthentication.hasHardwareAsync();
      const isEnrolled = await LocalAuthentication.isEnrolledAsync();

      if (hasHardware && isEnrolled) {
        setIsBiometricAvailable(true);
        handleBiometricAuth();
      } else {
        setErrorMessage("Biometric authentication is not set up.");
      }
    } catch (error) {
      setErrorMessage("Error checking biometric support.");
    }
  };

  const handleBiometricAuth = async () => {
    try {
      const result = await LocalAuthentication.authenticateAsync({
        promptMessage: "Unlock with Face ID / Touch ID",
        fallbackLabel: "Enter Password"});

      if (result.success) {
        onAuthSuccess();

        // navigation.replace("Investments");
      } else {
        const newFailedAttempts = failedAttempts + 1;
        setFailedAttempts(newFailedAttempts);
        if (newFailedAttempts >= 3) {
          logout();

          onAuthSuccess();
          Toast.show({
            type: "error",
            position: "top",
            text1: "Authentication failed. Please try logging in again.",
            visibilityTime: 4000});
        } else {
          setErrorMessage("Authentication failed. Try again.");
        }
      }
    } catch (error) {
      setErrorMessage("Error during authentication.");
    }
  };

  const sendTokenToApi = async (token: string) => {
    try {
      console.log("Sending token to API:", token);
      setIsLoading(true);
      const apiResponse: ApiResponse = await ApiService.post<{
        isSuccess: boolean;
        data: { token: string };
      }>("auth/login", { idToken: token });
      if (apiResponse.isSuccess) {
        console.log("API Response:", apiResponse);
        await AsyncStorage.setItem(
          "apiResponse",
          JSON.stringify(apiResponse.data.partner),
        );
        await AsyncStorage.setItem(
          "user",
          JSON.stringify(apiResponse.data.partner),
        );
        await AsyncStorage.setItem("userToken", apiResponse.data.token);
        await AsyncStorage.setItem(
          "userId",
          apiResponse.data.partner.id.toString(),
        );
        onAuthSuccess();
        setAuthToken();
        setUserToken(apiResponse.data.token);
        navigation.navigate("Investments");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error sending token to API:", error);
    }
  };
  const decodeToken = async (token: string) => {
    console.log("the tokens ", token);
    const decodedToken = jwtDecode.jwtDecode(token);
    console.log("the sss s", decodedToken);
    await storeUserInfo(JSON.stringify(decodedToken));
  };

  const storeUserInfo = async (userData: any) => {
    const data = typeof userData === "string" ? JSON.parse(userData) : userData;
    const profilePicture = data.picture || data.photo;
    if (profilePicture) {
      await AsyncStorage.setItem("setUserProfile", profilePicture);
    }
  };
  const signIn = async () => {
    try {
      await GoogleSignin.hasPlayServices();
      const response = await GoogleSignin.signIn();
      console.log("the response  off ", response);
      console.log("the email is ", response?.data?.user);
      if (isSuccessResponse(response)) {
        // const idToken = response?.data?.idToken;

        const idToken = response?.data?.idToken;
        if (idToken) {
          await storeUserInfo(JSON.stringify(response.data.user));
          sendTokenToApi(idToken);
        }
      } else {
        console.log("the ererer ");
      }
    } catch (error) {
      console.log("the ererer ", error);
      Toast.show({
        type: "error",
        text1: "Login",
        text2: `${error}`});
      if (isErrorWithCode(error)) {
        switch (error.code) {
          case statusCodes.IN_PROGRESS:
            break;
          case statusCodes.PLAY_SERVICES_NOT_AVAILABLE:
            break;
          default:
        }
      } else {
      }
    }
  };
  return (
    <SafeAreaView style={[{ flex: 1 }]}>
      <OverlayLoader visible={isLoading}></OverlayLoader>
      <KeyboardAvoidingView
        style={{ flex: 1 }}
        behavior={Platform.OS === "ios" ? "padding" : undefined}
      >
        <ScrollView
          contentContainerStyle={{ flexGrow: 1 }}
          keyboardShouldPersistTaps="handled"
        >
          <View style={SignInStyle.container}>
            <View style={SignInStyle.header}>
              <View style={SignInStyle.imageContainer}>
                <Image
                  source={require("../../../../assets/adaptive-icon.png")}
                  style={{ width: 350, height: 100 }}
                />
                <AppText style={[SignInStyle.subHeaderText, commonStyles.mt5]}>
                  #iamtheowner
                </AppText>
              </View>
            </View>
            <View style={SignInStyle.content}>
              <View
                style={[
                  SignInStyle.imageContainer,
                  { flex: 2, justifyContent: "center" },
                ]}
              >
                <Image
                  source={require("../../../../assets/images/login-page-image.png")}
                  style={SignInStyle.images}
                  resizeMode="contain"
                />
                <AppText style={styles.subtitle}>
                  Unlock with Biometric to open Epic Estates
                </AppText>
                {errorMessage ? (
                  <AppText style={styles.error}>{errorMessage}</AppText>
                ) : null}
              </View>

              <View style={[{ flex: 2, justifyContent: "center", gap: 10 }]}>
                {isBiometricAvailable && (
                  <TouchableOpacity
                    style={commonStyles.button}
                    onPress={handleBiometricAuth}
                    testID="biometric-button"
                  >
                    <AppText style={[commonStyles.buttonText, { fontSize: 20 }]}>
                      Use Biometric
                    </AppText>
                  </TouchableOpacity>
                )}
                <View style={SignInStyle.containerBtn}>
                  <GoogleSigninButton
                    onPress={signIn}
                    size={GoogleSigninButton.Size.Wide}
                    color={GoogleSigninButton.Color.Dark}
                    style={SignInStyle.hiddenButton}
                  />
                  <TouchableOpacity
                    style={SignInStyle.signinContainer}
                    onPress={signIn}
                  >
                    <Image
                      style={SignInStyle.image}
                      source={require("../../../../assets/images/google.png")}
                    />
                    <View style={SignInStyle.signButton}>
                      <AppText style={SignInStyle.signText}>
                        Sign in with Google
                      </AppText>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  subtitle: {
    fontSize: 16,
    color: "#666",
    textAlign: "center",
    marginBottom: 20},
  error: {
    color: "red",
    marginBottom: 10}});
export default BiometricAuthScreen;
